module.exports = __webpack_public_path__ + "static/media/ONLINE-v1.0.dcd1dd41.jpg";